<template>
  <div class="changePassword">
    <el-form
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
      class="demo-ruleForm"
    >
      <el-form-item :label="$t('register.nowPsw')" prop="nowPass">
        <el-input
          type="password"
          v-model="ruleForm.nowPass"
          autocomplete="off"
          maxlength="16"
          :placeholder="$t('register.imputOldPsw')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.psw')" prop="pass">
        <el-input
          type="password"
          v-model.trim="ruleForm.pass"
          autocomplete="off"
          maxlength="16"
          :placeholder="$t('rules.strongPwd')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('register.checkPsw')" prop="checkPass">
        <el-input
          type="password"
          v-model.trim="ruleForm.checkPass"
          autocomplete="off"
          maxlength="16"
          :placeholder="$t('register.checkPsw')"
        ></el-input>
      </el-form-item>
      <el-form-item class="submit-item">
        <el-button type="primary" size="medium" @click="submitForm('ruleForm')">{{$t('global.submit')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error(this.$t('register.psw1')));
    //   } else if (value.toString().length < 6 || value.toString().length > 16) {
    //     callback(new Error(this.$t('register.psw16')));
    //   } else {
    //     if (this.ruleForm.checkPass !== "") {
    //       this.$refs.ruleForm.validateField("checkPass");
    //     }
    //     callback();
    //   }
    // };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('register.checkTwice')));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error(this.$t('register.noSame')));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        nowPass: "",
        pass: "",
        checkPass: ""
      },
      rules: {
        nowPass: [
          { required: true, pattern: this.rules.strongPwd.reg, message: this.$t('rules.strongPwd'), trigger: "blur" }
        ],
        pass: [
          { required: true, pattern: this.rules.strongPwd.reg, trigger: 'blur', message: this.$t('rules.strongPwd') }
        ],
        checkPass: [
          { required: true, pattern: this.rules.strongPwd.reg, trigger: 'blur', message: this.$t('rules.strongPwd')},
          { validator: validatePass2, trigger: "blur" }
        ]
      },
      casFlag: false, //是否是单点登录
      longSocket:null,
      isTencentCloud: sessionStorage.getItem('tencentCloud'), // 是否为腾讯云平台
    };
  },
  created() {
    this.checkCas();
  },
  beforeDestroy () {
      if(this.longSocket){
          this.longSocket.close(); 
      }
  },
  methods: {
    // 判断当前是否单点登录跳
    checkCas() {
      let success = res => {
        if (res.data == "yes") {
          this.casFlag = true;
        } else {
          this.casFlag = false;
        }
      };
      this.$ajax.get("api/login/get_use_single_login", {
        params: {},
        func: { success: success }
      });
    },
    // 表单提交验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.changePass();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //验证通过，请求接口
    changePass() {
      let success = res => {
        this.initWS();
        this.loginOut();
      };
      this.$ajax({
        url: "api/login/changepass",
        method: "put",
        data: {
          nowPass: this.ruleForm.nowPass,
          newPass1: this.ruleForm.pass,
          newPass2: this.ruleForm.checkPass
        },
        func: { success: success }
      });
    },

    // 退出登录
    loginOut() {
      this.$message.success(this.$t('register.psw200'));
      setTimeout(() => {
        let success = res => {
          let host = sessionStorage.getItem("host_addr");
            window.location.href = host + "/user-login";
            // window.location.href = host
        };
        this.$ajax({
          url: "api/login/login",
          method: "delete",
          params: {},
          func: { success: success }
        });
      }, 3000);
    },
    initWS(){
        let webSocketURL
        if(Number(this.isTencentCloud)) {
          webSocketURL = 'wss:' + this.BASE_URL.split(':')[1] + ":7474";
        }else{
          webSocketURL = 'ws:' + this.BASE_URL.split(':')[1] + ":7474";
        }
        this.longSocket = new WebSocket(webSocketURL);

        this.longSocket.onopen = ((res) => {
            let params = {
                type: "edit_login",
                token: localStorage.getItem('token'),
                terminal_type: 1,
                delete_userid: this.$g.user_id,
            }

            this.longSocket.send(JSON.stringify(params));
        });
        this.longSocket.onmessage = (res => {});
        this.longSocket.onclose = (res => {})
    }
  }
};
</script>

<style lang="scss">
.changePassword {
  padding: 50px;
  width: 820px;

  .submit-item {
    // padding-top: 50px;
    text-align: left;
    margin-top: 50px;
    margin-left: 0;
    margin-bottom: 10px;

    .el-form-item__content{
      >button{
        border-color: #4477C3;
        background: #4477C3;
        transform: translate(-100px);
      }

    }

  }

}

</style>